import type { ClientRow, ManagedSite } from "../data/clients-sites";
import type { SiteRow } from "../data/routes";

/** Human-readable site label for pickers (disambiguates duplicate site names). */
export function formatSitePickerLabel(site: ManagedSite, clientName: string | undefined): string {
  const statusSuffix = site.status === "live" ? "" : " · setup";
  const clientSuffix = clientName !== undefined && clientName.length > 0 ? ` — ${clientName}` : "";
  return `${site.name}${clientSuffix}${statusSuffix}`;
}

/** Active sites for route/contact pickers, sorted by label. */
export function sitesForPicker(sites: ManagedSite[], clients: ClientRow[]): SiteRow[] {
  const clientNameById = new Map(clients.map((client) => [client.clientId, client.name]));
  return sites
    .filter((site) => site.active)
    .map((site) => ({
      siteId: site.siteId,
      siteName: formatSitePickerLabel(site, clientNameById.get(site.clientId)),
    }))
    .sort((a, b) => a.siteName.localeCompare(b.siteName));
}

/** Active clients for contact assignment pickers. */
export function clientsForPicker(clients: ClientRow[]): ClientRow[] {
  return clients.filter((client) => client.active);
}
